import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Input, OnInit } from '@angular/core';
import { AutoRenewService } from '@app/auto-renew/auto-renew.service';
import { PpApiGatewayService } from '@app/pp-api-gateway.service';
import { _ } from '@app/translation-marker';
import { Account } from '@app/types/account';
import { RatePlan } from '@app/types/rate-plan';
import { SessionStorage } from '@app/types/session-storage.enum';
import { Subscription } from '@app/types/subscription';
import { combineLatest } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'pp-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss'],
})
export class SubscriptionComponent implements OnInit {
  @Input() account: Account;
  @Input() subscription: Subscription;
  ratePlans: Array<RatePlan>;
  showTaxFootnote: boolean;
  xhrInProgress = true;
  isDesktop = true;
  statusTranslationKeys = {
    Active: _('status.active'),
    Suspended: _('status.suspended'),
    Cancelled: _('status.cancelled'),
    Draft: _('status.draft'),
  };
  taxFootnoteCountries = ['pt', 'tr'];

  constructor(
    private breakpointObserver: BreakpointObserver,
    private ppApiGateway: PpApiGatewayService,
    private autoRenewService: AutoRenewService
  ) {}

  ngOnInit() {
    this.showTaxFootnote = this.taxFootnoteCountries.includes(
      sessionStorage.getItem(SessionStorage.Country)
    );

    this.breakpointObserver
      .observe([Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
      .subscribe((result) => {
        this.isDesktop = result.matches;
      });

    this.autoRenewService.autoRenewUpdated$.pipe(
      tap(() => {
        this.xhrInProgress = true;
      }),
      switchMap(() =>  this.ppApiGateway.getSubscriptionRatePlanBySubscriptionName(
        this.subscription.subscriptionName
      ))
    ).subscribe((ratePlans) => {
      this.ratePlans = ratePlans;
      this.xhrInProgress = false;
    });
  }
}
